module.exports = __webpack_public_path__ + "static/media/DSC08574-2.4a3f87ba.jpeg";